import Table from './Component/TableBox/Table';
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" />
function App() {
  return (
    <div>
    <Table />
    </div>
  );
}

export default App;
